/*
  The portrait product card's Select Your Size panel is a normal
  document-flow element (see assets/base.css) — when it expands on
  hover, the card's own box genuinely gets taller, which is enough on
  its own for a plain CSS grid/flex row to grow, push the next row down,
  and grow the Shopify section around it. No JS needed for that case.

  Flickity carousels (Current Favorites, Collection Tabs' slider mode)
  are the one exception: Flickity positions each cell with
  position:absolute for horizontal dragging, and sets the
  .flickity-viewport's own height once from its internal cell
  measurements (viewport.style.height = tallest cell's measured height,
  via Flickity's setGallerySize()/maxCellHeight). It has no way to
  notice a cell growing taller from a CSS hover transition on its own —
  this asks it to remeasure, using the theme's own existing
  `jQuery(slider).flickity('resize')` call (see assets/theme.js), timed
  to fire just after the panel's own CSS transition finishes so Flickity
  measures the card's real, settled height rather than a mid-transition
  one.
*/
(function () {
  var TRANSITION_MS = 360;

  function resizeSlider(slider) {
    if (!slider || typeof jQuery === "undefined") return;
    var $slider = jQuery(slider);
    if ($slider.data("flickity")) {
      $slider.flickity("resize");
    }
  }

  function watch(cardInner) {
    var slider = cardInner.closest("[data-flickity-slider]");
    if (!slider) return;

    var timer = null;
    function scheduleResize() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        resizeSlider(slider);
      }, TRANSITION_MS);
    }

    cardInner.addEventListener("mouseenter", scheduleResize);
    cardInner.addEventListener("mouseleave", scheduleResize);
  }

  function init() {
    document
      .querySelectorAll(".product-card-inner.portrait-card")
      .forEach(watch);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
